// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'
import Notification from 'stimulus-notification'
import Sortable from 'stimulus-sortable'
import Carousel from 'stimulus-carousel'

const application = Application.start()
application.register('notification', Notification)
application.register('sortable', Sortable)

application.register('carousel', Carousel)
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(application, controllers)
